import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { PropertyUWContent, PropertyUWProforma } from '../propertyUnderwrite';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import {
  setProformaWidth, toggleTxnOppProformaIsOpen, fetchUWData, appNotify, setPropertyUWClientTxnOpp, setValuationIsDirty
} from 'store/actions';
import { Resizable } from 're-resizable';
import { LoadingOverlayWrapper } from 'components/layout';
import { Constants } from 'utilities/constants';
import debounce from 'lodash/debounce';
import PostAcqUWProforma from './PostAcqUWProforma';

const PropertyUW = ({ classes, location, txnOppProformaIsOpen, proformaWidth, setProformaWidth, toggleTxnOppProformaIsOpen,
  isFetchingPropertyUWData, isSyncingPurchaseState, propertyUWLoadingOverlayState,
  selectedOpportunity, fetchUWData, selectedContainer, history, channelWorkflowGridDataUpdate, appNotify,
  setPropertyUWClientTxnOpp, isPostAcquisitionUnderwrite, setValuationIsDirty
}) => {

  useEffect(() => {
    document.addEventListener('keydown', shortCutToggleProforma);
    return () => {
      document.removeEventListener('keydown', shortCutToggleProforma);
    }
  }, []);

  // Leaving the underwrite page discards any uncommitted valuation edits (the
  // user has already saved or discarded via the SaveUWDialog / NavigationLock
  // prompt). Clear the dirty flag on unmount so it doesn't linger in redux and
  // spuriously trigger the SaveUWDialog when navigating away from other pages
  // (e.g. the workflow grid). Re-entering the page re-fetches fresh data.
  useEffect(() => {
    return () => {
      setValuationIsDirty(false);
    }
  }, []);

  useEffect(() => {

    let abortController = new AbortController();
    const transactionOpportunityId = location.pathname.split(Constants.Routes.UNDERWRITE_PROPERTY + '/')[1];

    fetchUWData(parseInt(transactionOpportunityId), null, history);

    return () => {
      abortController.abort();
    }
  }, [location]);

  useEffect(() => {
    if(channelWorkflowGridDataUpdate?.data) {
      const isOppDeleted = Object.entries(channelWorkflowGridDataUpdate.data).some(pair => parseInt(pair[0]) === selectedOpportunity?.id && pair[1].type === 'remove');
      if(isOppDeleted) {
        setPropertyUWClientTxnOpp(null);
        appNotify(`Opportunity ${selectedOpportunity?.id} has been deleted`, 'error')
        history.push(Constants.Routes.HOME)
      }
    }
  }, [channelWorkflowGridDataUpdate])

  const onResize = debounce(() => {
    setProformaWidth(proformaResizable.resizable.clientWidth);
  }, 100);
  const shortCutToggleProforma = (args) => { // Short cut open proforma using [ctrl alt A]
    if (args.code === 'KeyA' && args.altKey && args.ctrlKey) {
      toggleTxnOppProformaIsOpen();
    }
  }

  let proformaResizable;  // Ref to resizable component, used to manually update size
  return (
    <LoadingOverlayWrapper
      className={classes.loadingOverlay}
      active={selectedOpportunity?.isProcessing || isFetchingPropertyUWData || isSyncingPurchaseState || propertyUWLoadingOverlayState.isLoading}
      message={selectedOpportunity?.isProcessing ? 'Processing  data...' : (isSyncingPurchaseState ? 'Syncing purchase state...' :  (isFetchingPropertyUWData ? 'Fetching underwrite data...' : propertyUWLoadingOverlayState.message))}
    >
      {selectedOpportunity && selectedContainer
        ? <div className={classes.container}>
            <PropertyUWContent />
            {txnOppProformaIsOpen
              ? <div>
                <Resizable ref={r => { proformaResizable = r; }} onResize={onResize} minWidth='300' maxWidth='400'
                  size={{ width: `${proformaWidth}px`, height: ('100%') }}
                  enable={{ top: false, right: false, bottom: false, left: true, topRight: false, bottomRight: false, bottomLeft: false, topLeft: false }}>
                  {isPostAcquisitionUnderwrite
                    ? <PostAcqUWProforma resizableWidth={proformaWidth} />
                    : <PropertyUWProforma resizableWidth={proformaWidth} />
                  }
                </Resizable>
              </div>
              : null
            }
          </div>
        : null
      }
    </LoadingOverlayWrapper>
  )
};

const mapStateToProps = (state) => ({
  isPostAcquisitionUnderwrite: state.propertyUWState.selectedProformaInputsContainer?.isPostAcquisitionUnderwrite,
  selectedOpportunity: state.propertyUWState.propertyUWClientTxnOpp,
  selectedContainer: state.propertyUWState.selectedContainer,
  txnOppProformaIsOpen: state.propertyUWState.txnOppProformaIsOpen,
  proformaWidth: state.propertyUWState.proformaWidth,
  isFetchingPropertyUWData: state.propertyUWState.isFetchingPropertyUWData,
  isSyncingPurchaseState: state.propertyUWState.isSyncingPurchaseState,
  propertyUWLoadingOverlayState: state.propertyUWState.propertyUWLoadingOverlayState,
  channelWorkflowGridDataUpdate: state.channelWorkflowState.channelWorkflowGridDataUpdate,
});

const mapDispatchToProps = {
  setProformaWidth,
  toggleTxnOppProformaIsOpen,
  fetchUWData,
  appNotify,
  setPropertyUWClientTxnOpp,
  setValuationIsDirty
};

const styles = theme => ({
  container: {
    display: 'flex',
    gridTemplateAreas: `'content proforma'`,
    gridTemplateColumns: '1fr auto',
    height: '100%',
    width: '100%'
  },
  loadingOverlay: {
    display: 'flex',
    width: '100%'
  }
});

export default compose(
  withRouter,
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(PropertyUW);